export class EnrollPrivilegesItems {
  privilege_name: number = null;
  privileges_files: any[] = [];
}



// WEBPACK FOOTER //
// ./src/app/modules/enroll/components/model/enroll-privileges-items.ts